// API client for Point Adjustments page
// Handles Unity Points redemption operations
// SSO Bearer token is attached automatically by apiClient (set in ProtectedApp)

import apiClient from '../../api/apiClient';
import config from '../../config';

// Format a date as UTC without milliseconds: yyyy-MM-ddTHH:mm:ssZ
function formatToUtcNoMillis(input) {
  const d = input ? new Date(input) : new Date();
  return d.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

export async function postUnityPointsAdjustment(args) {
  const { memberId, points, propertyCode, exchangeDate, reason, adjustmentUser } = args;

  // Convert date string (YYYY-MM-DD) to ISO datetime string without milliseconds
  const adjustmentDateTime = formatToUtcNoMillis(exchangeDate);

  const requestBody = {
    propertyCode,
    adjustmentDateTime,
    adjustmentAmount: String(points),
    adjustmentDescription: reason,
    ...(adjustmentUser && { adjustmentUser })
  };

  const url = `${config.operaExpBaseUrl}/v1/member/${memberId}/unity-points/adjustments`;
  return apiClient.post(url, requestBody);
}

export async function postTierPointsAdjustment(args) {
  const { memberId, points, propertyCode, adjustmentDateTime, reason, adjustmentUser } = args;

  const requestBody = {
    propertyCode,
    adjustmentDateTime: formatToUtcNoMillis(adjustmentDateTime),
    adjustmentAmount: String(points),
    adjustmentDescription: reason,
    ...(adjustmentUser && { adjustmentUser })
  };

  const url = `${config.operaExpBaseUrl}/v1/member/${memberId}/tier-points/adjustments`;
  return apiClient.post(url, requestBody);
}

export async function convertPointsToCurrency(args) {
  const { memberId, points, currencyCode, propertyCode, exchangeDate } = args;

  const requestBody = {
    points,
    currencyCode,
    propertyCode,
    // Backend field name is conversionDate
    conversionDate: exchangeDate || new Date().toISOString().split('T')[0],
  };

  const url = `${config.operaExpBaseUrl}/v1/member/${memberId}/unity-points/pointConversion/pointsToCurrency`;
  return apiClient.post(url, requestBody);
}

export async function convertCurrencyToPoints(args) {
  const { memberId, currencyValue, currencyCode, propertyCode, exchangeDate } = args;

  const requestBody = {
    currencyValue,
    currencyCode,
    propertyCode,
    // Backend field name is conversionDate
    conversionDate: exchangeDate || new Date().toISOString().split('T')[0],
  };

  const url = `${config.operaExpBaseUrl}/v1/member/${memberId}/unity-points/pointConversion/currencyToPoints`;
  return apiClient.post(url, requestBody);
}

export async function getCurrencies() {
  const url = `${config.operaExpBaseUrl}/v1/currencies`;
  return apiClient.get(url);
}

export async function getLocation(locationCode) {
  const url = `${config.operaExpBaseUrl}/v1/location/${locationCode}`;
  return apiClient.get(url);
}
